import React from 'react'

import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import { MessageDescriptorWithValues } from '../flashMessage'

interface RawFormattedMessageProps extends MessageDescriptorWithValues {
  className?: string
  tagName?: keyof JSX.IntrinsicElements
  isHTML?: boolean
}

export default function RawFormattedMessage (props: RawFormattedMessageProps) {
  const Tag = props.tagName || 'span'
  if (!props.id) {
    return null
  }
  if (props.isHTML) {
    return <FormattedHTMLMessage {...props} />
  }
  return (
    <FormattedMessage {...props}>
      {txt => <Tag className={props.className}>{txt}</Tag>}
    </FormattedMessage>
  )
}
